import store from "@/store";
import { getAffectedItemLists } from "../../..";
import { handleDifferentAndSamePriceList, handleDiscardList } from "../../../menu-switch-dialog";
import { addSelectedXChooseYPanel, removeSelectedXChooseYPanel } from "@/utils/va-order-test/testAndPanelSelection/xChooseYPanelSelection";

export function preparePanelForXChooseYDialog(panel, testList, bundleList, orderTestSupportObj) {
  panel.zoomerList = getZoomerListForXChooseYDialog(panel, testList);
  panel.supplementList = getSupplementListForXChooseYDialog(panel, testList, bundleList);
  initializePanelSelectionForXChooseYDialog(panel, orderTestSupportObj);
}

function getZoomerListForXChooseYDialog(bundle, testList) {
  let zoomerList = [];
  bundle.bundleContent.packageList.forEach(p => {
    let foundTest = testList.find(test => test.id === p.packageId);
    if (foundTest) {
      foundTest.isSelectForXChooseY = false;
      foundTest.isNotAllowedSelectForXChooseY = false;
      zoomerList.push(foundTest);
    }
  });
  return zoomerList;
}

function getSupplementListForXChooseYDialog(bundle, testList, bundleList) {
  if (!bundle.supplementContent) {
    return [];
  }
  let suppList = [];
  let { bundleIdList, itemIdList } = bundle.supplementContent;
  let suppPanels = bundleList
    .filter(p => bundleIdList.includes(p.bundleId));
  let suppTests = testList
    .filter(t => itemIdList.includes(t.id));
  suppPanels.concat(suppTests)
    .forEach(s => {
      s.isSelectForXChooseY = false;
      s.isNotAllowedSelectForXChooseY = false;
      suppList.push(s);
    });
  return suppList;
}

function initializePanelSelectionForXChooseYDialog(panel, orderTestSupportObj) {
  // select single tests and tests in discount panels that are already selected
  // if selected test is not in the pool, then select all its descendants instead
  let { selectedTestIdList, selectedItemList, testNodeList  } = orderTestSupportObj;
  let selectedZoomerQuantity = 0;
  let selectedSupplementQuantity = 0;
  panel.zoomerList.filter(test => selectedTestIdList.includes(test.id))
    .forEach(test => {
      if (selectedZoomerQuantity + 1 < panel.quantity) {
        test.isSelectForXChooseY = true;
        selectedZoomerQuantity += 1;
      } else {
        test.isNotAllowedSelectForXChooseY = true;
      }
    });
  panel.supplementList.filter(test => selectedTestIdList.includes(test.id))
    .forEach(test => {
      if (selectedSupplementQuantity + 1 <= panel.quantity) {
        test.isSelectForXChooseY = true;
        selectedSupplementQuantity += 1;
      } else {
        test.isNotAllowedSelectForXChooseY = true;
      }
    });
  
  let selectedDiscountPanels = selectedItemList.filter(item => item.category === "discountPanel");
  selectedDiscountPanels.forEach(discountPanel => {
    panel.zoomerList.filter(test => discountPanel.testIdsInPanel.includes(test.id))
      .forEach(test => {
        if (selectedZoomerQuantity + 1 < discountPanel.quantity) {
          test.isSelectForXChooseY = true;
          selectedZoomerQuantity += 1;
        } else {
          test.isNotAllowedSelectForXChooseY = true;
        }
      });
    panel.supplementList.filter(test => discountPanel.testIdsInPanel.includes(test.id))
      .forEach(test => {
        if (selectedSupplementQuantity + 1 <= discountPanel.quantity) {
          test.isSelectForXChooseY = true;
          selectedSupplementQuantity += 1;
        } else {
          test.isNotAllowedSelectForXChooseY = true;
        }
      });
  });

  // select panel's tests in other x choose y panels (if any) with less quantity than current bundle
  let selectedXChooseYPanelList = selectedItemList.filter(item => item.category === "xChooseY");
  selectedXChooseYPanelList.forEach(selectedXChooseYPanel => {
    let selectedZoomerIds = selectedXChooseYPanel.selectedZoomerIdList ? selectedXChooseYPanel.selectedZoomerIdList : [];
    let selectedZoomers = panel.zoomerList.filter(test => selectedZoomerIds.includes(test.id));
    if (selectedZoomerQuantity + selectedZoomers.length < panel.quantity) {
      selectedZoomers.forEach(zoomer => zoomer.isSelectForXChooseY = true);
      selectedZoomerQuantity += selectedZoomers.length;
    } else {
      selectedZoomers.forEach(zoomer => zoomer.isNotAllowedSelectForXChooseY = true);
    }
    let selectedSupplementIds = selectedXChooseYPanel.selectedSupplementIdList ? selectedXChooseYPanel.selectedSupplementIdList : [];
    let selectedSupplements = testNodeList.filter(test => selectedSupplementIds.includes(test.id)).map(node => node.value);
    if (selectedSupplementQuantity + selectedSupplements.length < panel.quantity) {
      selectedSupplements.forEach(supplement => supplement.isSelectForXChooseY = true);
      selectedSupplementQuantity += selectedSupplements.length;
    } else {
      selectedSupplements.forEach(supplement => supplement.isNotAllowedSelectForXChooseY = true);
    }
  });

  // special case: select all zoomers if the bundle quantity is equal to the lenght of zoomerList
  if (panel.quantity === panel.zoomerList.length) {
    panel.zoomerList.forEach(zoomer => !zoomer.isNotAllowedSelectForXChooseY && (zoomer.isSelectForXChooseY = true));
  }
}

export function addXChooseYPanelFromXChooseYDialog(panel, selectedItems, selectProp, orderTestSupportObj) {
  let { selectedTestIdList, selectedSupplementIdList } = selectedItems;
  panel.selectedZoomerIdList = selectedTestIdList;
  panel.selectedSupplementIdList = selectedSupplementIdList;
  //special handling: clear the selected supplement in other x choose y panels
  // NOTE that this part need to be reconsidered if not all food zoomer panels share the same supplement pool & quantity
  let { selectedItemList } = orderTestSupportObj;
  let selectedXChooseYPanelList = selectedItemList.filter(item => item.category === "xChooseY");
  selectedXChooseYPanelList.forEach(panel => {
    panel.selectedSupplementIdList = [];
  });
  // add console for sentry debug
  // console.log("panelId", panel.bundleId);
  // console.log("selected zoomer", [...panel.selectedZoomerIdList]);
  // console.log("selected supplement", [...panel.selectedSupplementIdList]);
  addSelectedXChooseYPanel(panel.bundleId, selectProp, orderTestSupportObj);
}

export function addAnyThreeAnyFivePanelFrom3For700Dialog(payload, orderTestSupportObj) {
  let { selectedTestIdList, dbsToggle } = payload;
  let { selectedItemList, dbsMap, bundleList, testNodeList, editOrderItemList } = orderTestSupportObj;
  // remove current selected three for 700 or 5 for 1000 if any
  if (selectedTestIdList.length === 3) {
    selectedItemList.filter(item => [2, 4].includes(item.bundleId)).forEach(item => {
      removeSelectedXChooseYPanel(item.bundleId, "isSelect", orderTestSupportObj);
    });
  }
  if (selectedTestIdList.length === 5) {
    selectedItemList.filter(item => [3, 5].includes(item.bundleId)).forEach(item => {
      removeSelectedXChooseYPanel(item.bundleId, "isSelect", orderTestSupportObj);
    });
  }
  selectedTestIdList.forEach(id => {
    store.dispatch("orderTest/addSelectedTest", {id});
  })
  store.dispatch("orderTest/setIsDbsVersion", dbsToggle);
  let changeVersionSupportObj = {
    selectedTestList: selectedItemList.filter(item => ["va", "vw"].includes(item.category)),
    selectedDiscountPanelList: selectedItemList.filter(item => item.category === "discountPanel"), 
    selectedCustomPanelList: selectedItemList.filter(item => item.category === "customPanel"), 
    selectedXChooseYPanelList: selectedItemList.filter(item => item.category === "xChooseY"), 
    selectedSeasonalPromoList: selectedItemList.filter(item => item.category === "seasonalPromo"), 
    selectedShortcutList: selectedItemList.filter(item => item.category === "shortcut"),
    dbsMap, 
    testList: testNodeList.map(node => node.value), 
    bundleList,
    editOrderItemList,
  };
  let { discardItemList, differentPriceItemList, samePriceItemList } = getAffectedItemLists(dbsToggle, changeVersionSupportObj);
  handleDiscardList(discardItemList, orderTestSupportObj);
  handleDifferentAndSamePriceList(differentPriceItemList, samePriceItemList, orderTestSupportObj);
}
